import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.match.js";
import "core-js/modules/es.symbol.match-all.js";
import "core-js/modules/es.symbol.replace.js";
import "core-js/modules/es.symbol.search.js";
import "core-js/modules/es.symbol.split.js";
import "core-js/modules/es.aggregate-error.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.reduce-right.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.global-this.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.math.hypot.js";
import "core-js/modules/es.number.parse-float.js";
import "core-js/modules/es.number.parse-int.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.promise.all-settled.js";
import "core-js/modules/es.promise.any.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.reflect.set.js";
import "core-js/modules/es.reflect.to-string-tag.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.match-all.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.trim-end.js";
import "core-js/modules/es.string.trim-start.js";
import "core-js/modules/es.typed-array.float32-array.js";
import "core-js/modules/es.typed-array.float64-array.js";
import "core-js/modules/es.typed-array.int8-array.js";
import "core-js/modules/es.typed-array.int16-array.js";
import "core-js/modules/es.typed-array.int32-array.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.uint8-clamped-array.js";
import "core-js/modules/es.typed-array.uint16-array.js";
import "core-js/modules/es.typed-array.uint32-array.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.from.js";
import "core-js/modules/es.typed-array.of.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.immediate.js";
import "core-js/modules/web.queue-microtask.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import 'react-image-lightbox/style.css';
import pdfjs from 'pdfjs-dist';
import { Provider } from 'react-redux';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Router } from 'react-router-dom';

/* eslint-disable-next-line no-unused-vars */
import about from './about/about';
import * as configs from './utils/configs';
import ga from './utils/ga';
import store from './reducers/storeRegistration';
import { registerActions } from './actions/entityActionRegistrar';
import App from './components/app';
import Notifier from './components/notifications/notifier';
import appHistory from './utils/appHistory';

// Configure PDF.js to use the worker file
pdfjs.GlobalWorkerOptions.workerSrc = 'js/pdfjsWorker.js';

// load the actions into the registry
registerActions();

// Setup Google Analytics
ga.initialize();

// other configuration.
configs.init();
const container = global.document.getElementById('app');
const root = createRoot(container);
root.render(/*#__PURE__*/React.createElement(Provider, {
  store: store
}, /*#__PURE__*/React.createElement(Router, {
  history: appHistory
}, /*#__PURE__*/React.createElement(App, null), /*#__PURE__*/React.createElement(Notifier, null))));